export const files = {
	uploadResource: 'files',
};